const FlutterIcon = ({ className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 166 202"
    className={className}
    aria-label="Flutter"
    role="img"
  >
    <defs>
      <linearGradient id="flutter_triangle">
        <stop offset="20%" stopColor="#000000" stopOpacity=".55" />
        <stop offset="85%" stopColor="#616161" stopOpacity=".01" />
      </linearGradient>

      <linearGradient id="flutter_rect" x1="0%" x2="0%" y1="0%" y2="100%">
        <stop offset="20%" stopColor="#000000" stopOpacity=".15" />
        <stop offset="85%" stopColor="#616161" stopOpacity=".01" />
      </linearGradient>
    </defs>

    <path fill="#42A5F5" fillOpacity=".8" d="M37.7 128.9 9.8 101 100.4 10.4 156.2 10.4" />
    <path fill="#42A5F5" fillOpacity=".8" d="M156.2 94 100.4 94 79.5 114.9 107.4 142.8" />
    <path fill="#0D47A1" d="M79.5 170.7 100.4 191.6 156.2 191.6 107.4 142.8" />

    <g transform="matrix(0.7071,-0.7071,0.7071,0.7071,-77.667,98.057)">
      <rect width="39.4" height="39.4" x="59.8" y="123.1" fill="#42A5F5" />
      <rect width="39.4" height="5.5" x="59.8" y="162.5" fill="url(#flutter_rect)" />
    </g>

    <path d="M79.5 170.7 120.9 156.4 107.4 142.8" fill="url(#flutter_triangle)" />
  </svg>
);

export default FlutterIcon;